<template>
  <v-card
    elevation="2"
    outlined
  >
    <v-toolbar
      class="primaryLight white--text"
      dense
    >
      <div>SOLICITANTE</div>
    </v-toolbar>
    <v-card-text>
      <v-row>
        <v-col
          cols="4"
        >
          <v-text-field
            v-model="datos.organismo"
            label="Organismo"
            disabled
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
        >
          <v-text-field
            v-model="datos.personaAutoriza"
            label="Persona que autoriza*"
            :rules="reglas.requerido"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
        >
          <v-combobox
            v-model="datos.cargo"
            :items="['Técnico de coordinación', 'Jefe de Jornada', 'Técnico de Guardia']"
            label="Cargo*"
            :rules="reglas.requerido"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="4"
        >
          <v-text-field
            v-model="datos.telefono"
            label="Teléfono*"
            type="tel"
            :rules="reglas.requerido"
            clearable
            hide-details
          />
        </v-col>
        <v-col
          cols="8"
        >
          <v-text-field
            v-model="datos.correo"
            label="Correo*"
            :rules="reglas.requerido"
            clearable
            hide-details
          />
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  props: {
    value: { type: Object, required: true }
  },
  data: () => ({
    reglas: { requerido: [v => !!v || 'Campo obligatorio'] }
  }),
  computed: {
    datos: {
      get() { return this.value },
      set(val) { this.$emit('input', val) }
    }
  }
}
</script>
